export const NAME = 'envelopeTypes';